export function jobLocation(job) {
  const town = String(job.town || "").trim();
  const country = String(job.country || "").trim();
  if (!town) return country || "Location not specified";
  if (!country) return town;
  const normalise = (value) => value.toLocaleLowerCase().replace(/\s+/g, " ").trim();
  const location = normalise(town);
  const suffix = normalise(country);
  if (location === suffix || location.endsWith(`, ${suffix}`) || location.endsWith(` ${suffix}`)) return town;
  return `${town}, ${country}`;
}
